import { pravicePridelavaService } from '../services/pravicePridelava.service';


const state = {
    pravicePridelava: null,
    sezona:null
};

const actions = {
    load({ dispatch,commit },{sezona}) {
      
        commit('setSezona', sezona)
        dispatch('alert/clear', "",{ root: true });
      return pravicePridelavaService.load(sezona)
            .then(
                pravicePridelava => {
                    commit('load', pravicePridelava)
                    return pravicePridelava;
                }
                
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    replace({ commit },{pravicePridelava}) {
        commit('replace',pravicePridelava);

    },
  
    save({ dispatch, commit },{pravicePridelava}) {
     

       dispatch('alert/clear', "",{ root: true });

         pravicePridelavaService.save(pravicePridelava)
            .then(
                item => {
                    
                    commit("update",pravicePridelava);
                    
                },
                error => {
                    console.log(error);
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
        
    }
};

const mutations = {
  
    load(state, pravicePridelava) {
        state.pravicePridelava = pravicePridelava;
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.pravicePridelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.pravicePridelava.splice(index,1,updated);
            } 

    },
   
};

export const pravicePridelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
